import React, { useContext, useEffect, useRef } from "react";
import "./ImageScrollbar.css";


const ImageScrollbar = (props) => {
  if (props.max === 0) {
    return null;
  }

  return (
    <div className="gizmo-viewport-scroll" style={{height: props.height}}>
      <div className="gizmo-viewport-scroll-holder">
      <input
        className="imageSlider"
        style={{width: props.height}}
        type="range"
        min="0"
        max={props.max}
        step="1"
        value={props.value}
        onChange={(e) => props.onChange(e)}
      />
    </div>
    </div>
  );
};

export default ImageScrollbar;
